var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.$vuetify.breakpoint.smAndUp)?_c('v-row',{staticClass:"tiers"},_vm._l((_vm.tiers),function(tier){return _c('v-col',{key:tier.title},[_c('Tier',{attrs:{"tier":tier}})],1)}),1):_vm._l((_vm.tiers),function(tier){return _c('v-row',{key:tier.title},[_c('v-col',[_c('Tier',{attrs:{"tier":tier}})],1)],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }